var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classroom-grid"},_vm._l((_vm.classrooms),function(classroom,index){return _c('classroom-grid-item',{key:'classroom-'+index,attrs:{"classroom":classroom},on:{"onViewDetail":_vm.onViewDetail}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }